
var FocusManager, ContextManager;

(function () {

  // Shallow equality compare for object arrays
  function arraysEqual(a, b, keys) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    var cmp = function (p, q) {
      for (var j in keys) {
        var k = keys[j];
        if (p[k] < q[k]) return -1;
        if (p[k] > q[k]) return 1;
        if (p[k] !== q[k]) return -1;	// handle undefined
      }
      return 0;
    };

    a.sort(cmp);
    b.sort(cmp);

    for (var i = 0; i < a.length; ++i) {
      for (var j in keys) {
        var k = keys[j];
        if (a[i][k] !== b[i][k]) return false;
      }
    }
    return true;
  }

  function factory(keys, required) {
    required = required || keys;

    var focus = [],
        listeners = [];

    // check that all items have values for all keys
    function validateItems(items) {
      items.forEach(function (item) {
        required.forEach(function (k) {
          if (!item[k]) {
            console.error("Invalid items list", item, k);
            throw new Error("Invalid items list", items);
          }
        });
      });
    }

    return {
      init: function () {},

      initFocus: function (items) {
        if (items) {
          if (!Array.isArray(items)) {
            items = [items];
          }

          validateItems(items);

          if (!arraysEqual(focus, items, keys)) {
            focus = items.slice();    // take a copy
          }
        }
      },

      refresh: function () {
        listeners.forEach(function (callback) {
          try {
              callback(focus);
          } catch (err) {
            console.log(err);
          }
        });
      },

      getFocus: function () {
        return focus.slice();        // return a copy
      },

      /*
       * items must be an Array of objects or undefined (indicating no change)
       * The objects must be one of the following forms:
       *
       *     { s: "system", c: "code", v: "version" }
       *     { q: "query", t: "??", i: "identifier" }
       *     { v: "valueSetUri", t: "title", s: "", i: "identifier" }
       */
      setFocus: function (items) {
        if (items) {
          if (!Array.isArray(items)) {
            items = [items];
          }
          
          validateItems(items);

          if (!arraysEqual(focus, items, keys)) {
            focus = items.slice();    // take a copy

            listeners.forEach(function (callback) {
              try {
                callback(focus);
              } catch (err) {
                console.log(err);
              }
            });
          }
        }
      },

      /*
       * See setFocus
       */
      toggleFocus: function (items) {
        if (items) {
          if (!Array.isArray(items)) {
            items = [items];
          }

          validateItems(items);

          var newFocus = focus.slice();    // take a copy

          // assumes that there are no duplicates in items array
          items.forEach(function(c) {
            var idx = -1;
            newFocus.forEach(function(d,i) {
              if (c.c === d.c && c.s === d.s && (!c.v || !d.v || c.v === d.v)) { idx = i; }
            });
            if (idx < 0) {
              newFocus.push(c);
            } else {
              newFocus = newFocus.slice(0,idx).concat(newFocus.slice(idx+1));
            }
          });

          this.setFocus(newFocus);
        }
      },

      addListener: function (listener) { listeners.push(listener); },
    };
  }

  FocusManager = factory(['s', 'c', 'v'], ['s', 'c']);
  ContextManager = factory(['v', 't', 'i', 's', 'version'], ['v', 't', 'i']);

}());

